export default __webpack_public_path__ + "static/Bitkub_logo-e57e2f7c69538784617c67787a068b4f.png";